import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ElbuildCoreComponentsModule } from 'elbuild-ui-componentslib';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BarRatingModule } from 'ngx-bar-rating';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { YFCSharedModule } from 'yf-commerce-ui-lib';
import { NgxUploaderModule } from "ngx-uploader";

@NgModule({
	declarations: [
		HeaderComponent,
		FooterComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		CarouselModule,
		BarRatingModule,
		LazyLoadImageModule,
		NgxSkeletonLoaderModule,
		TranslateModule,
		ElbuildCoreComponentsModule,
		YFCSharedModule,
		NgxUploaderModule
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		CarouselModule,
		BarRatingModule,
		LazyLoadImageModule,
		NgxSkeletonLoaderModule,
		TranslateModule,
		HeaderComponent,
		FooterComponent
	],
})
export class SharedModule { }
